import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { companyInfo, navLinks } from "../data/mock";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (href.startsWith("/#")) {
      const sectionId = href.replace("/#", "");
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          const el = document.getElementById(sectionId);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#061c2e] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-lg bg-[#ff9900] flex items-center justify-center">
                <span className="text-white font-bold text-lg">A</span>
              </div>
              <span className="font-semibold text-lg tracking-tight">
                {companyInfo.name}
              </span>
            </div>
            <p className="text-white/50 leading-relaxed max-w-md mb-6">
              {companyInfo.about}
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3 text-white/50">
                <MapPin className="w-4 h-4 text-[#ff9900] flex-shrink-0" />
                <span className="text-sm">{companyInfo.address}</span>
              </div>
              <div className="flex items-center gap-3 text-white/50">
                <Phone className="w-4 h-4 text-[#ff9900] flex-shrink-0" />
                <span className="text-sm">{companyInfo.phone}</span>
              </div>
              <div className="flex items-center gap-3 text-white/50">
                <Mail className="w-4 h-4 text-[#ff9900] flex-shrink-0" />
                <span className="text-sm">{companyInfo.email}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-5">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-white/50 hover:text-[#ff9900] transition-colors duration-200 text-sm"
                >
                  {link.label}
                </a>
              ))}
              <Link
                to="/products"
                className="text-white/50 hover:text-[#ff9900] transition-colors duration-200 text-sm"
              >
                All Products
              </Link>
            </nav>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-semibold text-white mb-5">Products</h4>
            <nav className="flex flex-col gap-3">
              {[
                "Water Level Indicator",
                "Pump Controller",
                "Fire Panel",
                "Motor Control Panel",
                "PLC Automation",
              ].map((name) => (
                <Link
                  key={name}
                  to="/products"
                  className="text-white/50 hover:text-[#ff9900] transition-colors duration-200 text-sm"
                >
                  {name}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-white/40 hover:text-[#ff9900] transition-colors duration-200 text-sm"
          >
            Back to top
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};
